import apiClient from "./apiClient";

// CONTACT SUBMIT API
export const submitContactForm = async (payload) => {
    try {
        const response = await apiClient.post("/contactsubmit", payload);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};